import React from 'react';
import { X } from 'lucide-react';

export const HistoryDashboardShell = ({
  ariaLabel,
  kicker,
  title,
  copy,
  gradientClassName = 'from-slate-900 via-blue-900 to-blue-700',
  accentClassName = 'bg-[radial-gradient(560px_260px_at_8%_0%,rgba(56,189,248,0.25),transparent_72%),radial-gradient(420px_220px_at_92%_0%,rgba(59,130,246,0.25),transparent_70%)]',
  closeAriaLabel = 'Close dashboard',
  onClose,
  sidebar,
  children,
}) => (
  <div className="modal-overlay p-3 md:p-5">
    <div
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel || kicker || title}
      className="modal-shell flex h-[92dvh] w-full max-w-[1140px] flex-col overflow-hidden rounded-[28px] bg-slate-50"
    >
      <div className={`relative overflow-hidden border-b border-white/20 bg-gradient-to-r ${gradientClassName} px-5 py-5 text-white md:px-7`}>
        <div className={`pointer-events-none absolute inset-0 ${accentClassName}`} />
        <div className="relative flex items-start justify-between gap-4">
          <div>
            {kicker && (
              <p className="inline-flex rounded-full border border-white/35 bg-white/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-blue-100">
                {kicker}
              </p>
            )}
            {title && (
              <h2 className="mt-3 text-2xl font-bold leading-tight text-white">
                {title}
              </h2>
            )}
            {copy && (
              <p className="mt-1 text-sm text-blue-100/90">
                {copy}
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-10 items-center gap-2 rounded-xl border border-white/35 bg-white/10 px-3 text-sm font-semibold text-white transition-colors hover:bg-white/20"
            aria-label={closeAriaLabel}
          >
            <X className="h-4 w-4" />
            Close
          </button>
        </div>
      </div>

      <div className="grid min-h-0 flex-1 grid-cols-1 md:grid-cols-[330px_1fr]">
        <aside className="max-h-[34vh] min-h-0 overflow-y-auto border-b border-slate-200 bg-white/85 p-4 md:max-h-none md:border-b-0 md:border-r md:p-5">
          {sidebar}
        </aside>

        <main className="min-h-0 overflow-y-auto p-4 md:p-6">
          {children}
        </main>
      </div>
    </div>
  </div>
);
